"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const checkOverIsMaiden = (props) => {
    if (!props.runsBatField)
        props.runsBatField = 'runs_bat';
    if (!props.runsExtraField)
        props.runsExtraField = 'runs_extra';
    if (!props.runsExtrasTypeField)
        props.runsExtrasTypeField = 'extras_type';
    let overTotal = 0;
    lodash_1.forEach(props.over, (ball) => {
        overTotal += ball[props.runsBatField];
        if (ball[props.runsExtrasTypeField] !== 3 && ball[props.runsExtrasTypeField] !== 4) {
            overTotal += ball[props.runsExtraField];
        }
    });
    return overTotal === 0;
};
exports.default = checkOverIsMaiden;
//# sourceMappingURL=checkOverIsMaiden.js.map